import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import integrationsService from "services/integrationsService";

export const getJiraData = createAsyncThunk("integrations/getJiraData", async (data, {
    rejectWithValue
}) => {
    try {
        return await integrationsService.getJiraData(data);
    } catch (error) {
        return rejectWithValue();
    }
});

export const createJiraIntegration = createAsyncThunk("integrations/createJiraIntegration", async (data, {
    rejectWithValue
}) => {
    try {
        return await integrationsService.createJiraIntegration(data);
    } catch (error) {
        return rejectWithValue();
    }
});

export const updateJiraIntegration = createAsyncThunk("integrations/updateJiraIntegration", async (data, {
    rejectWithValue
}) => {
    try {
        return await integrationsService.updateJiraIntegration(data, data?.id);
    } catch (error) {
        return rejectWithValue();
    }
});

const initialState = {
    jiraData: null,
    jiraLoading: false,
    error: null,
    success: null
}

export const integrationsSlice = createSlice({
    name: 'integrationsSlice',
    initialState,
    reducers: {
        resetJiraMessages: (state) => {
            state.error = null;
            state.success = null;
        }
    },
    extraReducers: (builder) => {
        //GET JIRA DATA
        builder.addCase(getJiraData.fulfilled, (state, action) => {
            state.jiraData = action.payload.data
            state.jiraLoading = false;
        });
        builder.addCase(getJiraData.pending, (state, action) => {
            state.jiraData = null;
            state.jiraLoading = true;
            state.success = null;
            state.error = null;
        });
        builder.addCase(getJiraData.rejected, (state, action) => {
            state.jiraLoading = false;
        });
        //CREATE JIRA INTEGRATION
        builder.addCase(createJiraIntegration.fulfilled, (state, action) => {
            state.jiraLoading = false;
            state.success = "jiraCreateSuccess";
        });
        builder.addCase(createJiraIntegration.pending, (state, action) => {
            state.jiraLoading = true;
            state.success = null;
            state.error = null;
        });
        builder.addCase(createJiraIntegration.rejected, (state, action) => {
            state.jiraLoading = false;
            state.error = "jiraCreateError";
        });
        //UPDATE JIRA INTEGRATION
        builder.addCase(updateJiraIntegration.fulfilled, (state, action) => {
            state.jiraLoading = false;
            state.jiraData = action.payload.data;
            state.success = "jiraUpdateSuccess";
        });
        builder.addCase(updateJiraIntegration.pending, (state, action) => {
            state.jiraLoading = true;
            state.success = null;
            state.error = null;
        });
        builder.addCase(updateJiraIntegration.rejected, (state, action) => {
            state.jiraLoading = false;
            state.error = "jiraUpdateError";
        });

    }
});


export const {
    resetJiraMessages
} = integrationsSlice.actions;

export default integrationsSlice.reducer;